import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { AddPermitTypeFormInputs } from '@src/permitTypesManager/AddPermitTypeFormInputs';
import { PermitTypeSectionCheckboxList } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import {
  TripBaseRegisteredWeightField,
  TripDestinationField,
  TripEffectiveDateField,
  TripEffectiveTimeField,
  TripFinalDestinationField,
  TripIncludesReturnTripField,
  TripMileageField,
  TripOriginalOriginField,
  TripOriginField,
  TripReturnDestinationField,
  TripReturnMileageField,
  TripReturnRouteField,
  TripRouteField,
} from '@src/permitTypesManager/permitTypeSections/TripInformationFields';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const TripInformationSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AddPermitTypeFormInputs>();

  const tripInformationSectionFields = [
    {
      field: TripOriginalOriginField,
      label: t('fields.tripOriginalOrigin'),
    },
    {
      field: TripFinalDestinationField,
      label: t('fields.tripFinalDestination'),
    },
    {
      field: TripOriginField,
      label: t('fields.tripOrigin'),
    },
    {
      field: TripDestinationField,
      label: t('fields.tripDestination'),
    },
    {
      field: TripBaseRegisteredWeightField,
      label: t('fields.tripBaseRegisteredWeight'),
    },
    {
      field: TripRouteField,
      label: t('fields.tripRouteField'),
    },
    {
      field: TripMileageField,
      label: t('fields.tripMileage'),
    },
    {
      field: TripIncludesReturnTripField,
      label: t('fields.tripIncludesReturnTrip'),
    },
    {
      field: TripReturnDestinationField,
      label: t('fields.tripReturnDestination'),
    },
    {
      field: TripReturnRouteField,
      label: t('fields.tripReturnRouteField'),
    },
    {
      field: TripReturnMileageField,
      label: t('fields.tripReturnMileage'),
    },
    {
      field: TripEffectiveDateField,
      label: t('fields.effectiveDate'),
    },
    {
      field: TripEffectiveTimeField,
      label: t('fields.effectiveTime'),
    },
  ];

  return (
    <Stack direction="column" gap={theme.spacing['1']}>
      <PermitTypeSectionCheckboxList
        sectionFields={tripInformationSectionFields}
        control={control}
      />
    </Stack>
  );
};
